import { useParams } from 'react-router-dom';
export const useClientIdParam = () => {
    const { clientId } = useParams();
    return clientId ? Number(clientId) : undefined;
};
